"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modelStoreReducer = modelStoreReducer;
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _modelStore = require("./modelStore");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function modelStoreReducer(state, action) {
  // console.log('modelStoreReducer', action)
  switch (action.type) {
    case 'setSignatureStatus':
      {
        if (!action.signature) {
          throw new TypeError('action.signature is required');
        }
        if (!action.status) {
          throw new TypeError('action.status is required');
        }
        return (0, _immutabilityHelper.default)(state, {
          signatureStatus: {
            [action.signature]: {
              $set: action.status
            }
          }
        });
      }
    case 'addRetrievedKeys':
      {
        var _state$endpointState$;
        if (!action.signatureWithoutKeys) {
          throw new TypeError('action.signatureWithoutKeys is required');
        }
        if (!action.keys) {
          throw new TypeError('action.keys is required');
        }
        let stateUpdate = {
          endpointState: {}
        };
        let newRetrievedKeys = (_state$endpointState$ = state.endpointState[action.signatureWithoutKeys]) !== null && _state$endpointState$ !== void 0 && _state$endpointState$.retrievedKeys ? state.endpointState[action.signatureWithoutKeys].retrievedKeys : [];
        for (let key of action.keys) {
          if (!newRetrievedKeys.includes(key)) {
            newRetrievedKeys.push(key);
          }
        }
        if (state.endpointState[action.signatureWithoutKeys]) {
          stateUpdate = {
            endpointState: {
              [action.signatureWithoutKeys]: {
                retrievedKeys: {
                  $set: newRetrievedKeys
                }
              }
            }
          };
        } else {
          stateUpdate = {
            endpointState: {
              [action.signatureWithoutKeys]: {
                $set: {
                  retrievedKeys: newRetrievedKeys
                }
              }
            }
          };
        }
        return (0, _immutabilityHelper.default)(state, stateUpdate);
      }
    case 'queueRequest':
      {
        if (!action.signature) {
          throw new TypeError('action.signature is required');
        }
        if (!action.route) {
          throw new TypeError('action.route is required');
        }
        if (!action.params) {
          throw new TypeError('action.params is required');
        }
        if (state.requestQueue.find(req => req.signature === action.signature)) {
          return state;
        } else {
          return (0, _immutabilityHelper.default)(state, {
            requestQueue: {
              $push: [{
                signature: action.signature,
                route: action.route,
                params: action.params,
                status: 'queued'
              }]
            }
          });
        }
      }
    case 'dequeueRequest':
      {
        if (!action.signature) {
          throw new TypeError('action.signature is required');
        }
        let idx = state.requestQueue.findIndex(req => req.signature === action.signature);
        if (idx >= 0) {
          return (0, _immutabilityHelper.default)(state, {
            requestQueue: {
              $splice: [[idx, 1]]
            }
          });
        } else {
          return state;
        }
      }
    case 'updateModel':
      {
        if (!action.data) {
          throw new TypeError('action.data is required');
        }
        if (!action.model) {
          throw new TypeError('action.model is required');
        }
        let data = action.data;
        let operation = action.operation;
        let model = action.model;
        let primaryKey = (0, _modelStore.getModelPrimaryKey)(model);
        if (!primaryKey) {
          throw new Error(`Model ${model} has no primaryKey`);
        }
        let newModelBytes = state.statistics.modelBytes[model];
        let stateUpdate = {
          model: {
            [model]: {}
          },
          modelUpdateCount: {
            [model]: {}
          },
          modelSyncErrorCount: {
            [model]: {}
          },
          lostSynch: {
            $set: state.lostSynch
          },
          statistics: {
            modelBytes: {
              [model]: {
                $set: newModelBytes
              }
            }
          }
        };
        if (operation === 'delete') {
          // Delete the given ids from the model
          let indicesToDelete = data.map(d => state.model[model].findIndex(m => m[primaryKey] === d));
          indicesToDelete = indicesToDelete.filter(i => i >= 0);
          // Sort indices in decreasing order
          indicesToDelete.sort((a, b) => b - a);
          stateUpdate.model[model] = {
            $splice: indicesToDelete.map(i => [i, 1])
          };
          for (let i of indicesToDelete) {
            newModelBytes -= JSON.stringify(state.model[model][i]).length;
          }
        } else {
          // Copy new data to state by updating existing object. New objects are pushed, existing objects are replaced.
          let modelUpdate = {
            $push: [],
            $splice: []
          };
          stateUpdate.model[model] = modelUpdate;
          for (let o of data) {
            if (o[primaryKey] == null) {
              console.error(`You attempted to dispatch an update action to "${model}" with an object that has no primary key, "${primaryKey}". The primary key is required.`);
              console.error(`The object was:`);
              console.error(o);
              throw new Error(`Cannot update model "${model}": object is missing primary key "${primaryKey}"`);
            }
            let itemIndex = state.model[model].findIndex(el => el[primaryKey] === o[primaryKey]);
            if (itemIndex < 0) {
              // No existing item found, push new item
              modelUpdate.$push.push(o);
              newModelBytes += JSON.stringify(o).length;
            } else {
              // Existing item found, replace it. Normally the order of items in $splice matters, but since were
              // replacing one item with one item, and pushing new items to the end of the array, the indices will be
              // correct.
              modelUpdate.$splice.push([itemIndex, 1, o]);
              newModelBytes += JSON.stringify(o).length - JSON.stringify(state.model[model][itemIndex]).length;
            }
          }
        }
        if (typeof action.serverUpdateCount === 'number') {
          let currentUpdateCount = state.modelUpdateCount[model];
          if (currentUpdateCount != null && action.serverUpdateCount !== currentUpdateCount + 1) {
            // If the update count is incorrect, report an error
            console.error(`The server update count for model "${model}" is incorrect. Expected ${currentUpdateCount + 1}, got ${action.serverUpdateCount}.`);
            console.error(`The update was:`);
            console.error(action);
            stateUpdate.lostSynch = {
              $set: true
            };
            stateUpdate.modelSyncErrorCount[model] = {
              $set: state.modelSyncErrorCount[model] + 1
            };
          }
          stateUpdate.modelUpdateCount[model] = {
            $set: action.serverUpdateCount
          };
        } else {
          // No update count given, don't update it
        }
        stateUpdate.statistics.modelBytes[model].$set = newModelBytes;
        return (0, _immutabilityHelper.default)(state, stateUpdate);
      }
    case 'dropModel':
      {
        if (!action.model) {
          throw new TypeError('action.model is required');
        }

        // Delete all signatureStatus keys matching this model
        let signatureStatus = {
          ...state.signatureStatus
        };
        for (let signature in signatureStatus) {
          if (signature.startsWith(`model=${action.model} `)) {
            // Don't forget the trailing space
            delete signatureStatus[signature];
          }
        }

        // Delete all endpointState keys matching the apiPaths that were deleted
        let endpointState = {
          ...state.endpointState
        };
        for (let signatureWithoutKeys in endpointState) {
          if (signatureWithoutKeys.startsWith(`model=${action.model} `)) {
            // Don't forget the trailing space
            delete endpointState[signatureWithoutKeys];
          }
        }
        let errorCount = {
          ...state.modelSyncErrorCount,
          [action.model]: 0
        };
        let numberOfModelsWithErrors = Object.keys(errorCount).filter(k => errorCount[k] > 0).length;
        return (0, _immutabilityHelper.default)(state, {
          endpointState: {
            $set: endpointState
          },
          signatureStatus: {
            $set: signatureStatus
          },
          model: {
            [action.model]: {
              $set: []
            }
          },
          modelUpdateCount: {
            [action.model]: {
              $set: null
            }
          },
          modelSyncErrorCount: {
            [action.model]: {
              $set: 0
            }
          },
          statistics: {
            modelBytes: {
              [action.model]: {
                $set: 0
              }
            }
          },
          lostSynch: {
            $set: numberOfModelsWithErrors > 0
          }
        });
      }
    case 'setNumberOfSubscribersByModel':
      {
        if (!action.model) {
          throw new TypeError('action.model is required');
        }
        if (action.numberOfSubscribers == null) {
          throw new TypeError('action.numberOfSubscribers is required');
        }
        return (0, _immutabilityHelper.default)(state, {
          numberOfSubscribersByModel: {
            [action.model]: {
              $set: action.numberOfSubscribers
            }
          }
        });
      }
    case 'subscribe':
      {
        if (!action.model) {
          throw new TypeError('action.model is required');
        }
        if (state.subscribedModels.includes(action.model)) {
          return state;
        } else {
          return (0, _immutabilityHelper.default)(state, {
            subscribedModels: {
              $push: [action.model]
            }
          });
        }
      }
    case 'unsubscribe':
      {
        if (!action.model) {
          throw new TypeError('action.model is required');
        }
        let idx = state.subscribedModels.findIndex(m => m === action.model);
        if (idx >= 0) {
          return (0, _immutabilityHelper.default)(state, {
            subscribedModels: {
              $splice: [[idx, 1]]
            }
          });
        } else {
          return state;
        }
      }
    case 'natsConnect':
      {
        return (0, _immutabilityHelper.default)(state, {
          natsConnected: {
            $set: true
          }
        });
      }
    case 'natsDisconnect':
      {
        return (0, _immutabilityHelper.default)(state, {
          natsConnected: {
            $set: false
          }
        });
      }
    case 'mutationRequestBegin':
      {
        return (0, _immutabilityHelper.default)(state, {
          statistics: {
            mutations: {
              pending: {
                $set: state.statistics.mutations.pending + 1
              }
            }
          }
        });
      }
    case 'mutationRequestEnd':
      {
        return (0, _immutabilityHelper.default)(state, {
          statistics: {
            mutations: {
              pending: {
                $set: state.statistics.mutations.pending - 1
              },
              complete: {
                $set: state.statistics.mutations.complete + 1
              }
            }
          }
        });
      }
    case 'retrievalRequestBegin':
      {
        return (0, _immutabilityHelper.default)(state, {
          statistics: {
            retrievals: {
              pending: {
                $set: state.statistics.retrievals.pending + 1
              }
            }
          }
        });
      }
    case 'retrievalRequestEnd':
      {
        return (0, _immutabilityHelper.default)(state, {
          statistics: {
            retrievals: {
              pending: {
                $set: state.statistics.retrievals.pending - 1
              },
              complete: {
                $set: state.statistics.retrievals.complete + 1
              }
            }
          }
        });
      }
    case 'authorizationFailed':
      {
        return (0, _immutabilityHelper.default)(state, {
          authorizationFailed: {
            $set: true
          }
        });
      }
    case 'authorizationSuccess':
      {
        return (0, _immutabilityHelper.default)(state, {
          authorizationFailed: {
            $set: false
          }
        });
      }
    default:
      // A TypeScript error will occur here if you have not handled all action types.
      const _exhaustiveCheck = action;
      console.log(_exhaustiveCheck);
      throw new Error('Unrecognized action');
  }
}